import { Query } from '../Model/Query';
import { Vehicle } from '../Model/Vehicle';
export class VehiclesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(vehicleId) {
        if (vehicleId) {
            const response = await this.apiService.get('vehicle/' + vehicleId);
            if (!response.ok) {
                throw new Error(`Error al obtener el tercero.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener VehicleId.`);
        }
    }
    async findVehicles(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`vehicles?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(vehicle => new Vehicle(vehicle).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findbyThird(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('vehicles_third/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener los vehículos.`);
            }
            const content = await response.json();
            if (content) {
                return content.map(vehicle => new Vehicle(vehicle).getState());
                ;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener thirdId.`);
        }
    }
    async saveVehicle(vehicle) {
        if (vehicle) {
            const response = await this.apiService.post('vehicle', vehicle);
            if (!response.ok) {
                throw new Error(`Error al guardar el tercero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async getQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`vehicles_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los vehículos.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
